import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from './Button';
import SvgWatchLater from '../../../../play-core/icons/WatchLater';
import SvgWatchLaterOutline from '../../../../play-core/icons/WatchLaterOutline';
import { useDataDispatch, useDataState } from '../../providers/DataProvider/DataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const WatchLaterCheckbox = ({
  videoUrn,
  onClick,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const dataDispatch = useDataDispatch();
  const {
    watchLaterState: {
      videoUrns
    }
  } = useDataState();
  const isAdded = useMemo(() => videoUrns.includes(videoUrn), [videoUrns, videoUrn]);
  return /*#__PURE__*/_jsx(SecondaryButton, {
    text: t('global.watchLater'),
    type: "text",
    ariaPressed: isAdded,
    icon: isAdded ? /*#__PURE__*/_jsx(SvgWatchLater, {}) : /*#__PURE__*/_jsx(SvgWatchLaterOutline, {}),
    onClick: e => {
      dataDispatch({
        type: 'toggle-watch-later',
        urn: videoUrn
      });
      onClick && onClick(!isAdded, e);
      e?.preventDefault();
    },
    ...rest
  });
};